export enum EntityType {
  QUEUE = 'QUEUE',
  PROFILE = 'PROFILE',
  PROFILE_PERMISSIONS = 'PROFILE_PERMISSIONS',
  USER = 'USER',
  USER_GROUPS = 'USER_GROUPS',
  QUEUE_TO_USER_MAPPINGS = 'QUEUE_TO_USER_MAPPINGS',
  USER_GROUP_TO_USER_MAPPINGS = 'USER_GROUP_TO_USER_MAPPINGS',
  TRD_MAPPINGS = 'TRD_MAPPINGS',
  TRD_TYPE = 'TRD_TYPE',
  TRD_REASON_FOR_CONTACT = 'TRD_REASON_FOR_CONTACT',
  TRD_DRIVER = 'TRD_DRIVER',
  TRD_ROOT_CAUSES = 'TRD_ROOT_CAUSES',
  CASE_ENTITY = 'CASE_ENTITY',
  EMAILS_ENTITY = 'EMAILS_ENTITY',
  LEGAL_REPORT = 'LEGAL_REPORT',
  DELETE_CASE_ENTITY = 'DELETE_CASE_ENTITY',
  ASSET_ENTITY = 'ASSET_ENTITY'
}

export enum UserCreationTabs {
  MANUAL = 'Manual',
  SEARCH = 'Search'
}

export enum SearchFilter {
  EMPLOYEE_ID = 'Employee ID',
  QUEUE_ID = 'Queue ID',
  QUEUE_NAME = 'Queue Name',
  PROFILE_ID = 'Profile ID',
  FIELD_ID = 'Field ID',
  USER_GROUP_ID = 'User Group ID',
  DRIVER = 'Contact Driver',
  TRD_TYPE = 'Type',
  TRD_REASON_FOR_CONTACT = 'Reason for Contact',
  TRD_DRIVER = 'Contact Driver',
  TRD_ROOT_CAUSES = 'Root Causes'
}

export enum ErrorCode {
  GENERIC_FAILURE = 'generic-failure',
  CONNECTION_ERROR = 'connection-error'
}

export enum STAGE {
  ALPHA = 'ALPHA',
  BETA = 'BETA',
  PROD = 'PROD'
}

export const DOMAIN_TO_STAGE: Record<string, STAGE> = {
  'admin-console.alpha.cases.pxt.amazon.dev': STAGE.ALPHA,
  'admin-console.beta.cases.pxt.amazon.dev': STAGE.BETA,
  'admin-console.prod.cases.pxt.amazon.dev': STAGE.PROD
};

export const DEFAULT_DOMAIN_TO_USECASE_MAP: Record<string, string> = {
  OPSHR: 'HRSC-PANO-OpsHR',
  MHLS: 'USCEmployeeResourceCentre',
  CTK: 'USCCentralizedTimeKeepingRecordType',
  HRP: 'HRSC-PANO-HRRegionalPartner',
  BXT_SE: 'USC-BXTSE',
  BALI: 'USCBALI',
  DALI: 'USCDALI',
  GWA: 'GlobalWorkAuthorization',
  ATP: 'USCPayroll',
  BST: 'CompassionateCareService',
  COE: 'HRSC-CenterOfExcellence',
  EMP_APPEAL: 'HRSC-EmpAppeal',
  MOBILITY: 'USCMobility',
  INTERVENTIONS: 'HRSC-Interventions',
  MC: 'USC-MedicalChecks',
  WA: 'USC-WorkAuth',
  DT: 'USC-DrugTesting',
  BGC: 'USC-Screening',
  NJS: 'USC-NJS',
  DEPARTURES: 'DeparturesCaseManager-DEPARTURES',
  IMH: 'USC-IMH'
};

export const MAPLE_ONBOARDED_DOMAINS = ['BXT_SE'];

export enum Domain {
  DALI = 'DALI'
}
